import { render } from "./BoqItemImagesModal.vue?vue&type=template&id=c1a80fa4&scoped=true"
import script from "./BoqItemImagesModal.vue?vue&type=script&lang=js"
export * from "./BoqItemImagesModal.vue?vue&type=script&lang=js"

import "./BoqItemImagesModal.vue?vue&type=style&index=0&id=c1a80fa4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a80fa4"]])

export default __exports__